<template>
  <div>
    <template>
      <el-table
        :header-cell-style="tableHeaderColor"
        style="width: 100%; margin-top: 1rem"
        :data="messageList"
      >
        <el-table-column prop="announcer" label="發送人" />
        <el-table-column prop="postTime" label="發訊時間" />
        <el-table-column prop="content" label="訊息內容" />
        <el-table-column prop="reference" label="來源">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.reference }}</span>
            <i v-if="scope.row.isImportant" class="el-icon-star-on"></i>
          </template>
        </el-table-column>
        <el-table-column prop="driverCallNumber" label="隊編/呼號" />
        <el-table-column prop="sendMessageAmount" label="發送車輛數" />
        <el-table-column prop="NotReplyMessageAmount" label="未讀取車輛數" />
        <el-table-column label="檢視">
          <template slot-scope="scope">
            <el-button type="primary" @click="onDetailBtnClick(scope.row.id)">
              檢視
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="width: fit-content; margin: 1rem auto"
        background
        layout="prev, pager, next"
        @current-change="onCurrentChange"
        :current-page="pagination.currentPage"
        :page-size="pagination.perPage"
        :total="pagination.totalEntries"
      />
    </template>
  </div>
</template>

<script>
export default {
  props: ['messageList', 'pagination'],
  methods: {
    tableHeaderColor({ rowIndex }) {
      if (rowIndex === 0) {
        return 'background-color: #445465;color: #fff;font-weight: 500;'
      }
    },
    onCurrentChange(value) {
      this.$emit('updateData', value)
    },
    onDetailBtnClick(id) {
      this.$router.push({ name: 'MessageDetail', params: { id } })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/hailState/DriverMessageList.vue